import React, {useEffect, useState} from "react";
import styles from "../../static/css/pages.module.css";

const EmptyData = (props) => {
  const [debt, setDebt] = useState(false);
  const [tax, setTax] = useState(false);
  const [penalty, setPenalty] = useState(false);
  useEffect(() => {
    if (props.data) {
      props.data.forEach(item => {
        if (item.type === 'DEBT') setDebt(true)
        if (item.type === 'TAX') setTax(true)
        if (item.type === 'PENALTY') setPenalty(true)
      })
    }
  }, [])
  return (
      <React.Fragment>
        {!tax?
            <div className={`${styles.history_item} ${styles.content_text}`} data-stroke>
              <div className="l-grid_pt-8">
                <div className="l-grid__item_4 l-grid_align-middle">
                Налоговое начисление
                </div>
                {props.partner?.paymentTax ?
                    null :
                    <div className="l-grid__item_3">{''}</div>
                }
                <div className="l-grid__item_1 l-grid_align-middle">
                  <div className="text_sum" data-amount>
                    0,00
                  </div>
                </div>
              </div>
            </div>
            : null
        }
        {!debt?
            <div className={`${styles.history_item} ${styles.content_text}`} data-stroke>
              <div className="l-grid_pt-8">
                <div className="l-grid__item_4 l-grid_align-middle">
                Задолженность
                </div>
                {props.partner?.paymentTax ?
                    null :
                    <div className="l-grid__item_3">{''}</div>
                }
                <div className="l-grid__item_1 l-grid_align-middle">
                  <div className="text_sum" data-amount>
                    0,00
                  </div>
                </div>
              </div>
            </div>
            : null
        }
        {!penalty?
            <div className={`${styles.history_item} ${styles.content_text}`} data-stroke>
              <div className="l-grid_pt-8">
                <div className="l-grid__item_4 l-grid_align-middle">
                  Пеня
                </div>
                {props.partner?.paymentTax ?
                    null :
                    <div className="l-grid__item_3">{''}</div>
                }
                <div className="l-grid__item_1 l-grid_align-middle">
                  <div className="text_sum" data-amount>
                    0,00
                  </div>
                </div>
              </div>
            </div>
            : null
        }
      </React.Fragment>
  )
}

export default EmptyData